###
# Параметры компонента:
#   type: ['checkbox', 'select', 'text', 'number']
#   name: string
#   text: string
#   values: [Object]
###
App.DraftDishAttributesComponent = Em.Component.extend
  classNames: ['draft-dish-attributes']

  draftDish:   null
  option: null
  onParameterChanged: ''
  isLoading: false

  isSelectShown: false

  initializeProperties: (->
    for type in ['checkbox', 'select', 'text', 'number']
      Em.defineProperty @, 'is' + type.capitalize(), Em.computed.equal('option.type', type)
  ).on('init')

  optionTextTranslated: (->
    @get("option.text_#{Em.I18n.locale}") || @get('option.text')
  ).property('option.text')

  optionValue: (->
    params = @get('draftDish.params')
    optionName = @get('option.name')
    currentParam = @get("draftDish.params.#{optionName}")
    @get('draftDish').set('params', {}) unless params
    unless currentParam
      defaultValue = @get('option.default')
      if defaultValue
        @get('draftDish').set("params.#{optionName}", defaultValue)
    if params and params.hasOwnProperty(optionName)
      optionValue = params[optionName]
      option = null
      for key, value of params
        if value == optionValue
          option = { value: value, text: key }
          break
      return option ? {}
    else
      return {}
  ).property('draftDish.params', 'option.name')


  textValueBinding: Em.Binding.oneWay('optionValue.value')

  numberValueBinding: Em.Binding.oneWay('optionValue.value')

  selectedValueBinding = Em.Binding.oneWay('optionValue.value')


  checkboxValue: ((key, value, previousValue) ->
    return null unless @get('isCheckbox')
    draftDish  = @get('draftDish')
    optionName = @get('option.name')
    params = draftDish.get('params')

    if arguments.length > 1
      unless params
        params = Ember.Object.create()
        Ember.set(params, optionName, value)
        draftDish.set('params', params)
      else
        Ember.set(params, optionName, value)
      @sendAction 'onParameterChanged'
    @get('optionValue.value')
  ).property(
    'optionValue'
    'optionValue.value')

  selectOptions: (->
    return unless @get('isSelect')
    selectedValue = @get('selectedValue')
    @get('option.values').map (v) ->
      value: v.value
      text: v.text
      isSelected: (v.value is selectedValue)
  ).property(
    'option.values.[]',
    'optionValue')

  selectedOptionLabel: (->
    return unless @get('isSelect')
    selectedValue = @get('selectedValue')
    params = @get('draftDish.params')
    return if selectedValue then selectedValue.text else if params then @get('option.values').find((option)=> option.value == params[@get('option.name')])?.text else ''
  ).property('optionValue', 'option.values.[]', 'selectedValue')


  actions:
    assignSelectValue: ->
      @set('isSelectShown', false)
      selectedOption = @get('selectedValue')
      draftDish  = @get('draftDish')
      optionName = @get('option.name')
      params = draftDish.get('params')
      unless params
        params = Ember.Object.create()
        Ember.set(params, optionName, selectedOption.value)
        draftDish.set('params', params)
      else
        Ember.set(params, optionName, selectedOption.value)
      @sendAction 'onParameterChanged'
      false

    textValueChanged: ->
      value = @get('textValue')
      draftDish = @get('draftDish')
      optionName = @get('option.name')
      params = draftDish.get('params')

      unless params
        params = Ember.Object.create()
        Ember.set(params, optionName, value)
        draftDish.set('params', params)
      else
        Ember.set(params, optionName, value)

      @sendAction 'onParameterChanged'
      false

    numberValueChanged: ->
      value = Number @get('numberValue')
      draftDish = @get('draftDish')
      optionName = @get('option.name')
      params = draftDish.get('params')

      unless params
        params = Ember.Object.create()
        Ember.set(params, optionName, value)
        draftDish.set('params', params)
      else
        Ember.set(params, optionName, value)

      @sendAction 'onParameterChanged'
      false

    toggleSelect: (event) ->
      @toggleProperty('isSelectShown')
      false


